import { rootApi } from "@/services/api/api";
import type { StateResponse } from "../types";

const stateApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getState: build.query<StateResponse, void>({
      query: () => ({
        url: "/state",
        methods: "GET",
        provideTags: ["authStatus"],
      }),
    }),
  }),
});

export const { useLazyGetStateQuery, useGetStateQuery } = stateApi;
